import React from 'react';
import { Row, Col, Spin } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/oicstat-logo.png';

export function Home() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const isRTL = lang === 'ar';
  const isFR  = lang === 'fr';

  const indicators     = Object.values(useSelector(state => state.privateIndicators.value || {}));
  const nonPrivateCount = indicators.filter(i => i.is_private === 0).length;
  const categories     = Object.values(useSelector(state => state.categories.value || {}));
  const publicCategoryCount = categories.filter(c => c.is_private === 0).length;
  const isLoading      = nonPrivateCount === 0;

  const containerStyle = {
    display:        'flex',
    flexDirection:  isRTL ? 'row-reverse' : 'row',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        10,
    margin:         10,
    borderRadius:   10,
    backgroundColor:'white',
    textAlign:      isRTL ? 'right' : 'left',
  };
  const logoStyle = {
    marginRight: isRTL ? 0  : 20,
    marginLeft:  isRTL ? 20 : 0,
    width:       120
  };
  const textStyle = {
    lineHeight:    '22.5px',
    fontWeight:    300,
    fontFamily:    'Roboto, sans-serif',
    direction:     isRTL ? 'rtl' : 'ltr',
    textAlign:     isRTL ? 'right' : 'left',
  };

  return (
    <Spin spinning={isLoading} tip={t('home.loading')} size="large">
      <Row style={containerStyle}>
        <Col>
          <img src={logo} alt={t('home.logoAlt')} style={logoStyle} />
        </Col>
        <Col style={{ width: '90%' }}>
          {isRTL ? (
            <p style={textStyle}>
              <strong>{t('home.oicstat')}</strong>
              {t('home.part1')}
              <a href="https://www.oic-oci.org/" target="_blank" rel="noopener noreferrer">
                {t('home.link1')}
              </a>
              {t('home.part2')}
              {t('home.part3')}
              <Link to="/features">{t('home.link2')}</Link>
              {t('home.part4', { count: nonPrivateCount })}
              <Link to="/indicators_list">{t('home.link3')}</Link>
              {t('home.part5', { categories: publicCategoryCount })}
            </p>
          ) : isFR ? (

              <p style={textStyle}>
                {/* 1) Make the database title itself a link */}
                  <strong>{t('home.databaseTitle')}</strong>
                {/* 2) Description up to the organization name */}
                {t('home.databaseDescription1')}
                {/* 3) Clickable org. name */}
                <a href="https://www.oic-oci.org/" target="_blank" rel="noopener noreferrer">
                  {t('home.databaseLink')}
                </a>
                {/* 4) The rest of the description */}
                {t('home.databaseDescription2')}{' '}
                {/* 5) “Features” link */}
                <Link to="/features">{t('home.userFriendlyFeatures')}</Link>{' '}
                {/* 6) Intro to the count */}
                {t('home.databaseDescription3')}{' '}
                <strong>{nonPrivateCount}</strong>{' '}
                {/* 7) “1852 indicateurs” link */}
                <Link to="/indicators_list">{t('home.indicatorsLink')}</Link>{' '}
                {/* 8) Final bit */}
                {t('home.databaseDescription4', { categories: publicCategoryCount })}.
              </p>
          ) : (
            <p style={textStyle}>
              <strong>{t('home.databaseTitle')}</strong>{' '}
              {t('home.databaseDescription1')}
              <a href="https://www.oic-oci.org/" target="_blank" rel="noopener noreferrer">
                {t('home.databaseLink')}
              </a>{' '}
              {t('home.databaseDescription2')}{' '}
              <strong>{t('home.oicstat')}</strong>{' '}
              {t('home.databaseDescription3')}{' '}
              <Link to="/features">{t('home.userFriendlyFeatures')}</Link>{' '}
              {t('home.databaseDescription4')}{' '}
              <strong>{nonPrivateCount}</strong>{' '}
              <Link to="/indicators_list">{t('home.indicatorsLink')}</Link>{' '}
              {t('home.databaseDescription5', { categories: publicCategoryCount })}.
            </p>
          )}
        </Col>
      </Row>
    </Spin>
  );
}
